module.exports = __webpack_public_path__ + "media/explosion.59e88900.wav";